import { isWysehubAdminPath } from './hostRouting'

const SIDEBAR_ROUTES = [
  '/demo',
  '/highlevelstats',
  '/homehub',
  '/kpidashboard',
  '/claimshire',
  '/myclaims',
  '/pgpartners',
  '/pgroleallocation',
  '/pguserpartner',
  '/recover-password',
  '/request',
  '/settings',
  '/uberaccident',
  '/claims',
  '/referrals',
  '/supplierrates',
  '/rates',
  '/source_rates',
  '/postcodearea',
]

/**
 * Whether ClientLayout should omit the global app Sidebar.
 *
 * Admin routes render AdminTopBar (including a mobile hamburger). Mounting
 * Sidebar there too stacks two menus on small screens. Desktop admin still
 * needs the app sidebar — the dedicated admin host is entirely `/admin/*`.
 */
export function shouldHideGlobalSidebar(
  pathname: string,
  isDesktop: boolean,
): boolean {
  if (isWysehubAdminPath(pathname)) {
    return !isDesktop
  }

  return (
    !SIDEBAR_ROUTES.includes(pathname) &&
    !pathname.startsWith('/claims/') &&
    !pathname.startsWith('/referrals/')
  )
}
